module.exports = __webpack_public_path__ + "static/media/content-07.46f890b3.png";